import React, { useCallback, useMemo } from 'react'
import StyledModal from '../../../components/CustomModal'
import { FooterButtons, FormWrapper, StyledButton } from "../../../components/styles";
import { AddButton } from '../../Category/styles';
import { Checkbox, Form, Input } from 'antd';
import { checkHasPermission } from '../../../utils/helpers/checkHasPermission';
import { useAppSelector } from '../../../utils/hooks/redux';
import { selectUserRole } from '../../../redux/features/auth/selectors';
import { permissions } from '../../../utils/constants/permissions';

interface UpdateStickyModalProps {
  handleFormSubmit: (values: any) => void;
  isMarkModalOpen: boolean;
  handleMarkCancel: () => void;
  handleMarkChange: (e: any) => void;
  form: any; // Form instance from antd Form component

}

const UpdateStickyModal: React.FC<UpdateStickyModalProps> = ({ handleFormSubmit, isMarkModalOpen, handleMarkCancel, handleMarkChange, form }) => {
  const userRole = useAppSelector(selectUserRole);

  const hasPermission = useCallback(
    (permissionKey: string) => checkHasPermission(userRole, permissionKey),
    [userRole]
  );

  const isMarkStickyAsDonePermission = useMemo(() => hasPermission(permissions.MarkStickyAsDone), [hasPermission]);

  return (
    <StyledModal
      draggable={true}
      title="Update Sticky"
      centered
      open={isMarkModalOpen}
      onCancel={handleMarkCancel}
      footer={
        <FooterButtons>
          <AddButton onClick={handleMarkCancel}>Cancel</AddButton>
          <AddButton onClick={() => form.submit()} type="primary">
            Update Sticky
          </AddButton>
        </FooterButtons>
      }
    >
      <FormWrapper
        form={form}
        name="Update_Sticky"
        layout="vertical"
        onFinish={handleFormSubmit}
      >
        <Form.Item
          name="stickyNote"
          label="Escalate Note"
          rules={[
            { required: true, message: "Please write a escalate note." }, // Validation rule
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Write a escalate note.."
          />
        </Form.Item>
        {isMarkStickyAsDonePermission && <Form.Item name="markAsDone" valuePropName="checked">
          <Checkbox onChange={handleMarkChange}>Mark as done</Checkbox>
        </Form.Item>}
      </FormWrapper>
    </StyledModal>
  )
}

export default UpdateStickyModal

